<template>
  <div>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>广东东进有害生东进公司工会成立大会暨第一届第一次<br>
          会员代表大会顺利召开物防控技术有限公司</h2>
        <p>
          为加强民主建设，维护员工的合法权益，2023年4月25日下午，“东进公司工会成立大会暨第一届第一次会员代表大会”在公司二楼会议室顺利召开。东进公司总经理王伟、东鸿公司工会主席张超、东进公司各会员代表共15人参加了会议。
        </p>
        <img width="100%" :src="img[0]" alt="">
        <p>
          会议在庄严的《国歌》中拉开了序幕，会上，首先由工会筹备组组长张雪婷作了工会筹备工作的报告，接着大会宣读了《广东东进有害生物防控技术有限公司工会第一次代表大会选举办法》。
        </p>
        <img width="100%" :src="img[1]" alt="">
        <p>
          会议通过了大会选举办法，以无记名投票的方式分别选举出东进公司工会第一届委员会、经费审查委员会。其中，东进公司综合管理部总监张雪婷当选为工会主席、品质管理部总监肖彪当选为工会副主席，计划财务部杨彩云当选为工会经费审查委员会主任。
        </p>
        <img width="100%" :src="img[2]" alt="">
        <p>
          会上，新当选的工会主席张雪婷作表态发言，表示将在今后工作中以习近平新时代中国特色社会主义思想为指导，把准工会工作方向，增强责任感和使命感，做广大员工的贴心人，为实现公司发展目标凝心聚力，贡献力量。
        </p>
        <img width="100%" :src="img[3]" alt="">
        <p>
          接着东进公司总经理王伟强调，工会要充分调动广大员工的积极性和创造性，引导广大员工立足本职，广泛开展多种形式的技能竞赛和形式多样的文体活动，引导员工树立正确的世界观、人生观、价值观，推动公司企业文化建设工作。
        </p>
        <img width="100%" :src="img[4]" alt="">
        <p>
          最后，东鸿公司工会主席张超向大会的顺利召开表示衷心的祝贺，并提出以下工作要求：一是上下联动，发挥好桥梁纽带作用；二是组织引导，发挥好员工主体作用；三是牢记宗旨，发挥好工会主力作用；四是关怀员工，发挥好凝心聚力作用。同时希望新当选的工会委员们牢记工会组织的宗旨、牢记广大员工的要求，在集团工联会和东鸿公司工会的领导下，从工会工作的性质、特点出发，结合公司发展的实际，全面履行工会的各项职能，切实维护、发展好广大工会会员的合法权益。
        </p>
      </div>
      <br>
      <br>
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({name: 'News6'})">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;防控知识宣传</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({name: 'News4'})">广东东进有害...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
        <!-- <el-col :span="12" :xs="24" :offset="0" class="hidden-sm-and-up">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({name: 'News4'})">下一条 &gt;
            &nbsp;&nbsp;&nbsp;&nbsp;广东东进有害...</span>
        </el-col> -->
      </el-row>
      <br>
      <br>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        img: [require('@/assets/1.jpg'), require('@/assets/2.jpg'), require('@/assets/3.jpg'), require('@/assets/4.jpg'), require('@/assets/5.jpg')]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kongxi {
    height: 10px;
  }

  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }

  @media screen and (max-width: 768px) {
    .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        margin: 20px 0;
        text-align: center;
        font-size: 24px;
      }

      p {
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        font-size: 16px;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
  }
</style>